import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId, EASE, CtaPrimary } from "./Shared";

const LINKS = [
  { label: "Work", target: "#work" },
  { label: "Manifesto", target: "#manifesto" },
  { label: "Services", target: "#services" },
  { label: "About", target: "#about" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    setTimeout(() => scrollToId(target), open ? 250 : 0);
  };

  return (
    <>
      <header className="fixed top-0 inset-x-0 z-[100] border-b border-white/10 backdrop-blur-md bg-obsidian/80">
        <div className="max-w-[1440px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
          <button
            data-testid="nav-logo"
            onClick={() => window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo({ top: 0, behavior: "smooth" })}
            className="font-display font-extrabold tracking-tight text-lg uppercase shrink-0"
          >
            Tomazo<span className="text-gold">.</span>
            <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 ml-2 hidden lg:inline">PRODUCTIONS</span>
          </button>

          <nav className="hidden md:flex items-center gap-4 lg:gap-8">
            {LINKS.map((l) => (
              <button
                key={l.label}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                onClick={() => go(l.target)}
                className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-400 hover:text-gold transition-colors duration-200"
              >
                {l.label}
              </button>
            ))}
            <CtaPrimary testid="nav-cta-book" onClick={() => go("#booking")} className="px-5 py-2.5">
              Book a Shoot
            </CtaPrimary>
          </nav>

          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-zinc-200 p-2"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[95] bg-obsidian/97 backdrop-blur-xl md:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            data-testid="nav-mobile-menu"
          >
            <div className="h-full flex flex-col justify-center px-8 gap-2">
              {[...LINKS, { label: "Book a Shoot", target: "#booking" }].map((l, i) => (
                <motion.button
                  key={l.label}
                  initial={{ opacity: 0, x: -24 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.08 + i * 0.06, duration: 0.5, ease: EASE }}
                  onClick={() => go(l.target)}
                  className="text-left font-display text-4xl font-bold uppercase tracking-tight text-zinc-100 hover:text-gold transition-colors py-2"
                >
                  <span className="font-mono text-xs text-gold mr-4 align-middle">0{i + 1}</span>
                  {l.label}
                </motion.button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
